import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useShop } from "@/context/Shop";
import { BagLines, BagSummary } from "@/components/store/CartDrawer";
import { useSeo } from "@/hooks/useSeo";

export default function Cart() {
  const { cart, customer, config } = useShop();
  const navigate = useNavigate();
  useSeo("Your bag", "Review the items in your bag.");
  if (cart.items.length === 0) {
    return (
      <div className="container-lux py-24 text-center" data-testid="cart-empty-page">
        <ShoppingBag className="h-10 w-10 mx-auto text-muted-foreground" strokeWidth={1.1} />
        <h1 className="font-display text-4xl mt-6">Your bag is empty</h1>
        <p className="text-sm text-muted-foreground mt-3 max-w-md mx-auto">Begin by exploring new arrivals or your saved wishlist.</p>
        <div className="flex justify-center gap-3 mt-8">
          <Link to="/new-arrivals" className="btn-ink" data-testid="cart-empty-shop-link">Shop new in</Link>
          <Link to="/wishlist" className="btn-ghost-lux" data-testid="cart-empty-wishlist-link">View wishlist</Link>
        </div>
      </div>
    );
  }
  return (
    <div className="container-lux py-10" data-testid="cart-page">
      <h1 className="font-display text-5xl font-medium">Your bag</h1>
      <p className="text-sm text-muted-foreground mt-2">{cart.item_count} {cart.item_count === 1 ? "item" : "items"} saved for you.</p>
      <div className="grid lg:grid-cols-12 lg:gap-14 mt-10">
        <div className="lg:col-span-7" data-testid="cart-lines-wrap"><BagLines /></div>
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28 bg-white border rounded-lg p-6 lg:p-8" data-testid="cart-summary-card">
            <h2 className="font-display text-2xl mb-5">Order summary</h2>
            <BagSummary />
            {!customer && config?.checkout_enabled && (
              <p className="text-xs text-muted-foreground mt-5 leading-relaxed" data-testid="cart-signin-hint">
                <Link to="/account/login" className="link-lux text-foreground">Sign in</Link> to speed up checkout and save addresses.
              </p>
            )}
            <div className="flex items-center gap-2 mt-6 text-xs text-muted-foreground" data-testid="cart-reassurance"><span>Prices in EUR · 14-day returns</span></div>
          </div>
        </div>
      </div>
      <div className="mt-14 flex justify-between items-center border-t pt-6">
        <Link to="/new-arrivals" className="text-[12px] uppercase tracking-[0.14em] link-lux" data-testid="cart-continue-shopping-link">Continue shopping</Link>
        <button onClick={() => navigate("/account/login")} className="text-[12px] uppercase tracking-[0.14em] link-lux lg:hidden">Sign in</button>
      </div>
    </div>
  );
}
